import { Component, HostListener, inject } from "@angular/core";
import { CommonModule } from '@angular/common';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { RouterLinkWithHref } from '@angular/router';
import { SharedModule } from 'primeng/api';
import { IServiceLink } from '../../../../interfaces/IServiceLink';
import { ButtonModule } from 'primeng/button';
// import { MetrikaGoalDirective } from 'ng-yandex-metrika';
// import { InlineSVGModule } from '@rentaggregator/inline-svg';
import { ContentDesktopButtonTooltipDirective } from "../tooltip/content-desktop-button-tooltip.directive";
import { UserSpaceBtnComponent } from "../user-space/buttons/user-space-btn.component";
import {ClientSideRenderingDirective} from '../../../../../../common/directives/client-side-rendering.directive';

@Component({
  selector: 'ra-ad-create-button',
  standalone: true,
  imports: [
    CommonModule,
    OverlayPanelModule,
    RouterLinkWithHref,
    SharedModule,
    ButtonModule,
    // MetrikaGoalDirective,
    // InlineSVGModule,
    ClientSideRenderingDirective,
    ContentDesktopButtonTooltipDirective,
    UserSpaceBtnComponent,
  ],
  templateUrl: './ad-create-button.component.html',
  styleUrls: ['./ad-create-button.component.scss'],
})
export class AdCreateButtonComponent {
  menuState = false;
  links: IServiceLink[] = [
    {
      name: 'Коммерческая недвижимость',
      link: '/kommercheskaya-nedvizhimost',
      reachGoal: 'clickRazmestitObyavlenie',
      queryParams: { modal: 'select' },
    },
    {
      name: 'Транспорт',
      link: '/lk/transport/rent/create',
      queryParams: {},
      reachGoal: 'clickRazmestitObyavlenie',
    },
    {
      name: 'Спецтехника',
      link: '/lk/com-transport/rent/create',
      reachGoal: 'clickRazmestitObyavlenie',
      queryParams: {},
    },
  ];

  generateLink(link: string, queryParams?: { [key: string]: any }): string {
    if (!queryParams || Object.keys(queryParams).length === 0) {
      return `https://rentag.ru${link}`;
    }
    const queryString = Object.keys(queryParams)
      .map(
        (key) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`
      )
      .join('&');
    return `https://rentag.ru${link}?${queryString}`;
  }


    @HostListener('mouseleave') onMouseLeave() {
    this.menuState = false;
  }
}
